import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { EmailVerificationBanner } from "@/components/EmailVerificationBanner";
import { OrderTrackerDock } from "@/components/OrderTrackerDock";
import { useLocation } from "wouter";
import { useEffect } from "react";
import "./premier-order.css";

export function AppLayout({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();
  const premierShop = location === "/order/premier-dean-street";
  const premierEmbed = premierShop && window.parent !== window ? new URLSearchParams(window.location.search).get("premierEmbed") : null;
  const embeddedPremierBasket = premierEmbed === "basket";
  const embeddedPremierProduct = premierEmbed === "product";
  const premierBranded = embeddedPremierBasket || embeddedPremierProduct;
  useEffect(() => {
    document.body.classList.toggle("premier-order-mode", premierBranded);
    document.body.classList.toggle("premier-embedded-basket", embeddedPremierBasket);
    document.body.classList.toggle("premier-embedded-product", embeddedPremierProduct);
    return () => {
      document.body.classList.remove("premier-order-mode");
      document.body.classList.remove("premier-embedded-basket");
      document.body.classList.remove("premier-embedded-product");
    };
  }, [premierBranded, embeddedPremierBasket, embeddedPremierProduct]);
  return (
    <div className={`min-h-[100dvh] flex flex-col bg-slate-50${premierBranded ? " premier-order-shell" : ""}`}>
      {premierBranded ? (
        <header className="premier-order-header">
          <a href="/premier/" aria-label="Premier Dean Street home"><img src="/premier/premier-logo.png" alt="Premier" /></a>
          <nav aria-label="Premier shop navigation">
            <a href="/premier/#deals">Deals</a>
            <a href="/premier/#range">Browse</a>
            <a href="/order/premier-dean-street?basket=1">Basket</a>
          </nav>
        </header>
      ) : <Navbar />}
      <EmailVerificationBanner />
      <main className="flex-1 flex flex-col">
        {children}
      </main>
      {premierBranded ? (
        <footer className="premier-order-footer">
          <a href="/premier/">Premier Dean Street</a>
          <span>Online ordering by <a href="/">Ayrshire Hub</a></span>
          <div><a href="/privacy">Privacy</a><a href="/terms">Terms</a></div>
        </footer>
      ) : <Footer />}
      {/* Site-wide live order tracker. Renders nothing unless the signed-in
          customer has an active order — see OrderTrackerDock. */}
      <OrderTrackerDock />
    </div>
  );
}
